import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

export const useUpsertFoetalObservation = (consultationId) => {
  const queryClient = useQueryClient();
  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useMutation({
    mutationFn: async (payload) => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.post(
        `${tenantVal}/antenatalconsultationfoetalobservation`,
        { tenant: tenantVal, ...payload }
      );
      return response.data?.data ?? response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["foetalObservations", consultationId, localStorage.getItem("kinesin-tenant")],
      });
    },
    onError: (error) => console.error("Failed to save foetal observation:", error),
    meta: { skipGlobalError: true },
  });
};
